import { OWF_IMPROVE_TERMS_TOUCHPOINTS_PDP_SHIPPING_240820 } from "@faire/web-api/indigofair/settings/OWF_IMPROVE_TERMS_TOUCHPOINTS_PDP_SHIPPING_240820";

import { useAssignSetting, useSetting } from "./__internal__/useSetting";

export const useSettingOwFImproveTermsTouchpointsPDPShipping = (): boolean =>
  useSetting(OWF_IMPROVE_TERMS_TOUCHPOINTS_PDP_SHIPPING_240820, false);

export const useAssignSettingOwFImproveTermsTouchpointsPDPShipping = () =>
  useAssignSetting(OWF_IMPROVE_TERMS_TOUCHPOINTS_PDP_SHIPPING_240820);
